import { useForm } from "@repo/ui/hooks/use-form";
import { Input } from "@repo/ui/components/form/input";
import { Button } from "@repo/ui/components/button";
import { setToken } from "@repo/api-client/lib/auth";
import { GeneralError } from "@repo/ui/components/form/general-error";
import { useNavigate } from "react-router";
import { urlLogin } from "../urls";
import { QrScan } from "../components/qr-scan";
import { useState } from "react";
import { LogInIcon, QrCodeIcon } from "lucide-react";

function Login() {
  const [enableScanner, setEnableScanner] = useState(false);
  const navigate = useNavigate();
  const {
    ref,
    values,
    errors: formErrors,
    handleChangeValue,
  } = useForm({
    initialValues: {
      posToken: "",
    },
    onSubmit: async () => {
      setToken(values.posToken, false);
      navigate("/");
    },
  });
  const handleScan = (value: string) => {
    handleChangeValue("posToken", value);
    setEnableScanner(false);
  };
  return (
    <div className="flex items-center justify-center h-screen max-w-md mx-auto w-full">
      <form ref={ref} className="flex flex-col gap-4 w-full">
        {enableScanner ? <QrScan onScan={handleScan} /> : null}
        <Input
          label="POS Token"
          name="posToken"
          type="text"
          required
          errors={formErrors}
          value={values.posToken}
          onChange={(e) => handleChangeValue("posToken", e.target.value)}
        />
        <GeneralError errors={formErrors} />
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="flex-1"
            onClick={() => setEnableScanner(!enableScanner)}
          >
            <QrCodeIcon className="w-4 h-4" />
            Escanear QR
          </Button>
          <Button type="submit" className="flex-1" size="lg">
            <LogInIcon className="w-4 h-4" />
            Iniciar sesión
          </Button>
        </div>
      </form>
    </div>
  );
}

export const route = {
  path: urlLogin(),
  element: <Login />,
};
